import { ColorBookApiModel } from '../../../types/models/color-book.model';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchColorBooksApiRequest } from '../../../types/requests/color-books/search-color-books.request';

export const searchColorBooks = <T extends ColorBookApiModel>(params: SearchColorBooksApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/color-books`, { params });
